import Arrow from './Arrow'
import Button  from './Button'
import SVGButton  from './SVGButton'


import Spinner from './Spinner'
import Flex from './Flex'
import Div from './Div'

import {SelectInput, TextInput, AreaInput, ToogleInput, FileInput,
    SlideInput, NumberInput, RadioInput, ToogleSwitch} from './Forms'
import SearchInput from './Forms/SearchInput'




import Modal from './Modal'



export {
    Flex, Div,
    Arrow,
    Button, SVGButton,
    SelectInput, TextInput, AreaInput, ToogleInput,
    SlideInput, NumberInput, RadioInput, FileInput, ToogleSwitch,
    SearchInput,
    Spinner,
    Modal,
}



// WEBPACK FOOTER //
// src/component/index.js